import {memo, useEffect, useState} from "react";

const SuccessBox = ({
  text,
  displayTime = 6000,
}: {
  text: string;
  displayTime?: number;
}) => {
  // Only the dismissal is state; the message itself is read straight from the
  // prop. Mirroring it into state would show the message one paint late,
  // because a passive effect runs after the browser has already painted the
  // previous value.
  const [dismissed, setDismissed] = useState<string | null>(null);

  useEffect(() => {
    if (!text || displayTime === 0) return;

    // hide the success box after the display time elapses
    const timeoutId = setTimeout(() => {
      setDismissed(text);
    }, displayTime);

    return () => clearTimeout(timeoutId);
  }, [text, displayTime]);

  if (!text || dismissed === text) return null;

  return (
    <div className="text-on-success bg-success border-success px-g-3 mt-g-1 transition-in-circle-center flex flex-col items-center rounded-md border py-3 text-center select-none">
      {text}
    </div>
  );
};

// render the component only if the text is not null
export default memo(SuccessBox);
